import { vars } from '@croquiscom-pvt/zds/tokens';

export const ZSymbolIcon = ({
  width = 10,
  height = 15,
  color = vars.v3Color.gray900,
  ...props
}: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} viewBox='0 0 10 15' fill='none' {...props}>
    <path
      d='M0.226998 0.265442V3.5374H4.12682L0 14.2654H8.96005V10.9861H5.09065L9.1875 0.265442H0.226998Z'
      fill={color}
    />
  </svg>
);
